import React from "react";
import { X, Plus, Minus, Trash2 } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, remove, total } = useCart();
  const nav = useNavigate();

  return (
    <>
      {open && (
        <div
          className="fixed inset-0 bg-black/40 z-50 transition-opacity"
          onClick={() => setOpen(false)}
          data-testid="cart-overlay"
        />
      )}
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full sm:w-[440px] bg-alimi-bg z-50 shadow-2xl transform transition-transform duration-500 ease-out flex flex-col ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between p-6 border-b border-alimi-border">
          <div>
            <div className="overline">Il tuo carrello</div>
            <div className="font-serif text-2xl mt-1">{items.length} {items.length === 1 ? "articolo" : "articoli"}</div>
          </div>
          <button onClick={() => setOpen(false)} data-testid="cart-close" aria-label="Chiudi carrello">
            <X size={22} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {items.length === 0 && (
            <div className="text-center text-alimi-inkSoft mt-20">
              <div className="font-serif text-2xl mb-3">Il carrello è vuoto</div>
              <p className="text-sm">Scopri le nostre creazioni e aggiungi qualcosa di unico.</p>
            </div>
          )}

          {items.map((it) => (
            <div key={it.product_id} className="flex gap-4" data-testid={`cart-item-${it.product_id}`}>
              <div className="w-24 h-28 bg-alimi-surface2 overflow-hidden">
                {it.image && <img src={it.image} alt={it.name} className="w-full h-full object-cover" />}
              </div>
              <div className="flex-1 flex flex-col">
                <div className="font-serif text-base">{it.name}</div>
                <div className="text-xs text-alimi-inkSoft mt-1">€ {it.price.toFixed(2)}</div>
                <div className="flex items-center gap-3 mt-auto">
                  <button onClick={() => updateQty(it.product_id, it.quantity - 1)} className="p-1 border border-alimi-border" data-testid={`qty-dec-${it.product_id}`}><Minus size={12} /></button>
                  <span className="text-sm w-6 text-center">{it.quantity}</span>
                  <button onClick={() => updateQty(it.product_id, it.quantity + 1)} className="p-1 border border-alimi-border" data-testid={`qty-inc-${it.product_id}`}><Plus size={12} /></button>
                  <button onClick={() => remove(it.product_id)} className="ml-auto text-alimi-inkSoft hover:text-alimi-terracotta" data-testid={`cart-remove-${it.product_id}`}><Trash2 size={14} /></button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {items.length > 0 && (
          <div className="border-t border-alimi-border p-6 space-y-4">
            <div className="flex justify-between text-sm">
              <span className="text-alimi-inkSoft">Subtotale</span>
              <span data-testid="cart-subtotal" className="font-serif text-lg">€ {total.toFixed(2)}</span>
            </div>
            <p className="text-[0.7rem] text-alimi-inkSoft">Spedizione calcolata al checkout.</p>
            <button
              data-testid="cart-checkout-btn"
              className="btn-primary w-full"
              onClick={() => { setOpen(false); nav("/checkout"); }}
            >
              Procedi al checkout
            </button>
          </div>
        )}
      </aside>
    </>
  );
}
